import { createI18n } from 'vue-i18n'

export const i18n = createI18n({
  legacy: false,
  locale: typeof localStorage === 'undefined' ? 'zh-CN' : localStorage.getItem('coldwise-locale') || 'zh-CN',
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': {
      appName: '冷智云',
      common: {
        actions: '操作', addFilter: '添加筛选', addLine: '增加明细', all: '全部', cancel: '取消',
        chooseColumn: '选择列表列', columnSettings: '列设置', deleteLine: '删除行', details: '详情',
        documentActions: '单据操作', edit: '编辑', freeze: '冻结', freezeTitle: '冻结在左侧',
        input: '输入{label}', new: '新建', noPermission: '没有查看权限', query: '查询',
        operationFailed: '操作失败，请稍后重试', optionsLoadFailed: '选项加载失败，请重新展开下拉重试', actionSuccess: '操作成功', required: '请填写{label}', saveSuccess: '保存成功',
        reset: '重置', restoreDefault: '恢复默认', restoreDrawer: '还原抽屉', expandDrawer: '拓展为全屏', save: '保存', select: '请选择',
        showOrderFreeze: '显示 / 顺序 / 冻结', system: '系统', document: '单据', lines: '明细',
        export: '导出', exporting: '导出中…', import: '导入', totalRows: '共 {count} 条', dragToReorder: '拖动调整顺序（或用↑↓键）', frozenGroup: '冻结列', normalGroup: '普通列',
        columnDragHint: '拖动左侧手柄调整组内顺序；跨组请先修改冻结状态。',
      },
      nav: {
        approvals: '审批工作台', approvalFlows: '审批流配置', rolePermissions: '角色权限', userAdmin: '员工账号', documentNumbering: '单据编号', reports: '报表分析',
        groups: { masterData: '基础档案', procurement: '采购', sales: '销售', inventory: '库存', finance: '财务', system: '系统' },
      },
      shell: { initialPassword: '当前为初始密码，请尽快修改。', logout: '退出登录', changePassword: '修改密码', comingSoon: '功能建设中' },
      auth: {
        tagline: '冻品冷链业财一体化系统', account: '账号', accountRequired: '请输入账号', password: '密码',
        passwordRequired: '请输入密码', remember: '记住我', login: '登录', loginFailed: '登录失败',
        brand: '冷智云', brandEn: 'ColdWise Cloud', leftTag: '冻品冷链 · 业财一体化',
        pageTitle: '登录 ColdWise', pageSubtitle: '冻品冷链业财一体化管理平台',
        usernamePlaceholder: '请输入账号', passwordPlaceholder: '请输入密码', signingIn: '登录中…',
        empty: '请输入账号和密码', artLabel: '冷链仓储示意图',
        footer: '© 2026 冷智云 ColdWise · 冻品冷链业财一体化平台',
        changeTitle: '修改初始密码', changeHint: '首次登录需要设置新的个人密码。', currentPassword: '当前密码',
        newPassword: '新密码', confirmPassword: '确认新密码', mismatch: '两次输入的新密码不一致',
        changeFailed: '修改密码失败', saveAndLogin: '保存并重新登录',
        personalPasswordHint: '更新个人密码，保护你的账户安全。',
        currentPasswordPlaceholder: '请输入当前密码', newPasswordPlaceholder: '请输入新密码',
        confirmPasswordPlaceholder: '请再次输入新密码',
        changeSuccess: '密码已修改，请使用新密码重新登录。',
        passwordSessionNote: '保存后将退出当前登录，请使用新密码重新登录。',
      },
      route: {
        forbiddenTitle: '没有查看权限', forbiddenSubtitle: '当前账号无权访问此页面。',
        notFoundTitle: '页面不存在', notFoundSubtitle: '该功能未配置或地址不正确。',
      },
      status: {
        available: '可售', reserved: '旧版占用（待核实）', quarantine: '待检', frozen: '冻结',
        disposal: '待处理', isolated: '隔离待判',
        draft: '草稿', pending: '待审批', approved: '已审核', partial: '部分执行', in_transit: '在途',
        pending_handover:'待交接', signed:'全部签收', refused:'全部拒收', completed_with_refusal:'签收结束·含拒收',
        executed: '已执行', fully_converted: '全部转单', partially_converted: '部分转单',
        closed: '已关闭', voided: '已作废', reversed: '已冲销', open: '未结清',
        settled: '已结清', estimated: '暂估待票', matched: '已匹配', service: '服务发票确认', disputed: '差异待处理', not_required: '不适用',
        rejected: '已驳回', withdrawn: '已撤回', warning: '临期预警', critical: '严重临期', expired: '已过期',
      },
      approval: {
        records: '审批记录', empty: '暂无审批记录', submit: '提交', approve: '同意', reject: '驳回', withdraw: '撤回',
        workspace: '审批工作台', todo: '待我审批', requested: '我发起的', handled: '我已处理', refresh: '刷新',
        viewProcess: '查看 / 处理', details: '审批详情', opinion: '审批意见；驳回时必填',
        rejectRequired: '驳回必须填写意见', completed: '审批操作已完成', loadFailed: '审批列表加载失败', actionFailed: '审批操作失败',
      },
      report: {
        scopedHint: '按当前账号的数据范围查询', chooseSupplier: '请先选择供应商。',
        expiryHint: '当前有 {count} 个临期或过期批次，请按预警等级处理。',
        payableTotal: '应付合计', paid: '已付', outstanding: '未付', loadFailed: '报表加载失败',
      },
      flow: {
        title: '审批流配置', subtitle: '按单据类型启停、排序审批节点和设置不含税金额门槛', new: '新建流程',
        snapshotHint: '修改流程只影响之后提交的单据；待审批单据保留提交时的节点快照。', documentType: '单据类型',
        flowName: '流程名称', currentVersion: '当前版本', configStatus: '配置状态', enabled: '已开启', disabled: '未开启',
        editTitle: '编辑审批流', newTitle: '新建审批流', save: '保存配置', englishName: '英文名称', enable: '启用审批',
        nodes: '审批节点', level: '第 {level} 级', moveUp: '上移', moveDown: '下移', delete: '删除', nodeName: '节点名称',
        assigneeType: '审批人类型', role: '角色', user: '指定用户', assignee: '审批角色或人员', chooseRole: '请选择角色',
        chooseUser: '请选择用户', minAmount: '审批金额门槛', addNode: '增加审批节点',
        loadFailed: '审批流配置加载失败', required: '请填写单据类型和流程名称', nodesRequired: '开启流程前请配置审批节点',
        nodeInvalid: '每个节点都需要名称和审批角色或人员', saved: '审批流已保存；进行中的审批仍按原快照执行',
        saveFailed: '审批流保存失败，请刷新后重试',
      },
    },
    en: {
      appName: 'ColdWise',
      common: {
        actions: 'Actions', addFilter: 'Add filter', addLine: 'Add line', all: 'All', cancel: 'Cancel',
        chooseColumn: 'Choose a list column', columnSettings: 'Columns', deleteLine: 'Delete line', details: 'Details',
        documentActions: 'Document actions', edit: 'Edit', freeze: 'Freeze', freezeTitle: 'Freeze on the left',
        input: 'Enter {label}', new: 'New', noPermission: 'No access', query: 'Search',
        operationFailed: 'The operation failed. Please try again.', optionsLoadFailed: 'Could not load options. Reopen the list to retry.', actionSuccess: 'Operation completed', required: 'Enter {label}', saveSuccess: 'Saved',
        reset: 'Reset', restoreDefault: 'Restore defaults', restoreDrawer: 'Restore drawer', expandDrawer: 'Expand to full screen', save: 'Save', select: 'Select',
        showOrderFreeze: 'Visible / Order / Frozen', system: 'System', document: 'Document', lines: 'Lines',
        export: 'Export', exporting: 'Exporting…', import: 'Import', totalRows: '{count} rows', dragToReorder: 'Drag to reorder (or use ↑↓ keys)', frozenGroup: 'Frozen columns', normalGroup: 'Normal columns',
        columnDragHint: 'Drag the left handle within a group. Change the freeze setting to move between groups.',
      },
      nav: {
        approvals: 'Approval workspace', approvalFlows: 'Approval flows', rolePermissions: 'Role permissions', userAdmin: 'Employee accounts', documentNumbering: 'Document numbering', reports: 'Reports',
        groups: { masterData: 'Master data', procurement: 'Procurement', sales: 'Sales', inventory: 'Inventory', finance: 'Finance', system: 'System' },
      },
      shell: { initialPassword: 'You are using an initial password. Change it as soon as possible.', logout: 'Sign out', changePassword: 'Change password', comingSoon: 'Coming soon' },
      auth: {
        tagline: 'Integrated cold-chain inventory, sales, and finance', account: 'Account', accountRequired: 'Enter your account', password: 'Password',
        passwordRequired: 'Enter your password', remember: 'Remember me', login: 'Sign in', loginFailed: 'Sign-in failed',
        brand: 'ColdWise', brandEn: 'ColdWise Cloud', leftTag: 'Cold-chain · Integrated Operations & Finance',
        pageTitle: 'Sign in to ColdWise', pageSubtitle: 'Cold-chain food ERP — inventory, trade and finance in one',
        usernamePlaceholder: 'Username', passwordPlaceholder: 'Password', signingIn: 'Signing in…',
        empty: 'Please enter username and password', artLabel: 'Cold-chain warehouse illustration',
        footer: '© 2026 ColdWise · Cold-chain food ERP',
        changeTitle: 'Change initial password', changeHint: 'Set a personal password the first time you sign in.', currentPassword: 'Current password',
        newPassword: 'New password', confirmPassword: 'Confirm new password', mismatch: 'The new passwords do not match',
        changeFailed: 'Password change failed', saveAndLogin: 'Save and sign in again',
        personalPasswordHint: 'Update your personal password to keep your account secure.',
        currentPasswordPlaceholder: 'Enter your current password', newPasswordPlaceholder: 'Enter a new password',
        confirmPasswordPlaceholder: 'Enter the new password again',
        changeSuccess: 'Password changed. Please sign in with your new password.',
        passwordSessionNote: 'Saving signs you out. Sign in again with your new password.',
      },
      route: {
        forbiddenTitle: 'No access', forbiddenSubtitle: 'Your account cannot access this page.',
        notFoundTitle: 'Page not found', notFoundSubtitle: 'This module is not configured or the address is incorrect.',
      },
      status: {
        available: 'Saleable', reserved: 'Legacy reservation (unverified)', quarantine: 'Pending inspection', frozen: 'Frozen',
        disposal: 'Pending disposal', isolated: 'Isolated',
        draft: 'Draft', pending: 'Pending approval', approved: 'Approved', partial: 'Partially executed', in_transit: 'In transit',
        pending_handover:'Awaiting handover', signed:'Signed', refused:'Refused', completed_with_refusal:'Completed with refusal',
        executed: 'Executed', fully_converted: 'Fully converted', partially_converted: 'Partially converted',
        closed: 'Closed', voided: 'Voided', reversed: 'Reversed', open: 'Open',
        settled: 'Settled', estimated: 'Estimated', matched: 'Matched', service: 'Service invoice confirmed', disputed: 'Disputed', not_required: 'Not applicable',
        rejected: 'Rejected', withdrawn: 'Withdrawn', warning: 'Expiring soon', critical: 'Critical', expired: 'Expired',
      },
      approval: {
        records: 'Approval history', empty: 'No approval history', submit: 'Submitted', approve: 'Approve', reject: 'Reject', withdraw: 'Withdraw',
        workspace: 'Approval workspace', todo: 'My pending approvals', requested: 'Requested by me', handled: 'Handled by me', refresh: 'Refresh',
        viewProcess: 'View / process', details: 'Approval details', opinion: 'Approval comment; required when rejecting',
        rejectRequired: 'A rejection comment is required', completed: 'Approval action completed', loadFailed: 'Failed to load approvals', actionFailed: 'Approval action failed',
      },
      report: {
        scopedHint: 'Results are limited to the current account data scope', chooseSupplier: 'Select a supplier first.',
        expiryHint: '{count} batches are expiring or expired. Process them by alert level.',
        payableTotal: 'Total payable', paid: 'Paid', outstanding: 'Outstanding', loadFailed: 'Failed to load report',
      },
      flow: {
        title: 'Approval flow configuration', subtitle: 'Enable flows by document type, order nodes, and set pre-tax amount thresholds', new: 'New flow',
        snapshotHint: 'Changes apply only to later submissions. Pending documents keep the node snapshot captured at submission.', documentType: 'Document type',
        flowName: 'Flow name', currentVersion: 'Current version', configStatus: 'Status', enabled: 'Enabled', disabled: 'Disabled',
        editTitle: 'Edit approval flow', newTitle: 'New approval flow', save: 'Save configuration', englishName: 'English name', enable: 'Enable approval',
        nodes: 'Approval nodes', level: 'Level {level}', moveUp: 'Move up', moveDown: 'Move down', delete: 'Delete', nodeName: 'Node name',
        assigneeType: 'Approver type', role: 'Role', user: 'Specific user', assignee: 'Approver role or user', chooseRole: 'Select a role',
        chooseUser: 'Select a user', minAmount: 'Approval amount threshold', addNode: 'Add approval node',
        loadFailed: 'Failed to load approval flows', required: 'Enter the document type and flow name', nodesRequired: 'Add approval nodes before enabling this flow',
        nodeInvalid: 'Every node requires a name and an approver role or user', saved: 'Approval flow saved. Active approvals continue with their original snapshots.',
        saveFailed: 'Failed to save the approval flow. Refresh and try again.',
      },
    },
  },
})

export interface LocalizedLabel {
  label: string
  labelEn?: string
}

export function localizedLabel(item: LocalizedLabel, locale: string): string {
  return locale === 'en' && item.labelEn ? item.labelEn : item.label
}

export function setAppLocale(next: 'zh-CN' | 'en'): 'zh-CN' | 'en' {
  i18n.global.locale.value = next
  if (typeof localStorage !== 'undefined') localStorage.setItem('coldwise-locale', next)
  return next
}

export function toggleAppLocale(): 'zh-CN' | 'en' {
  return setAppLocale(i18n.global.locale.value === 'zh-CN' ? 'en' : 'zh-CN')
}
